const JFROG_BASE = "https://runai.jfrog.io/artifactory" as const;

export const INFRASTRUCTURE = {
  JFROG: {
    BASE: JFROG_BASE,

    HELM: {
      STAGING: `${JFROG_BASE}/api/helm/op-charts-staging`,
      PROD: `${JFROG_BASE}/api/helm/op-charts-prod`,
      LOCAL: `${JFROG_BASE}/helm-local`,
    },

    NPM: {
      REGISTRY: `${JFROG_BASE}/api/npm/runai-npm`,
      LOCAL: `${JFROG_BASE}/api/npm/npm-local`,
    },

    DOCKER: {
      LOCAL: `${JFROG_BASE}/docker-local`,
    },
  },

  GOOGLE_STORAGE: {
    HELM: {
      STAGING: "https://run-ai-charts-staging.storage.googleapis.com",
      PROD: "https://run-ai-charts.storage.googleapis.com",
    },
  },
} as const;

export type InfrastructureType = typeof INFRASTRUCTURE;

export default INFRASTRUCTURE;
